import React, { useState } from 'react';
import InputField from '../common/InputField';
import Button from '../common/Button';
import PropTypes from 'prop-types';
import Logo from '../common/Logo';

const PasswordRecoveryForm = ({ onSwitchForm, onSubmit, error, onResetError }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage('');
    
    try {
      const result = await onSubmit(email);
      if (result && result.success) {
        setSuccessMessage(result.message || 'Istruzioni per il recupero password inviate. Controlla la tua email.');
        setEmail('');
      }
    } catch (err) {
      // L'errore viene gestito nel componente parent
      console.error('Error in password recovery submission:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (onResetError) {
      onResetError();
    }
    setSuccessMessage('');
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white rounded-lg w-full max-w-md">
      <Logo />
      <h2 className="text-2xl font-bold mb-2 text-center">Recupera la tua password</h2>
      <p className="text-gray-600 mb-6">Inserisci la tua email per ricevere le istruzioni</p>
      
      {error && (
        <div className="mb-4 p-2 bg-red-100 border border-red-400 text-red-700 rounded">
          {error}
        </div>
      )}
      
      {successMessage && (
        <div className="mb-4 p-2 bg-green-100 border border-green-400 text-green-700 rounded">
          {successMessage}
        </div>
      )}
      
      <InputField
        type="email"
        placeholder="Email"
        className="mb-6 w-full border border-orange-300 rounded-md p-2"
        value={email}
        onChange={handleEmailChange}
        required
      />
      
      <Button
        type="submit"
        text={isSubmitting ? "Invio istruzioni in corso..." : "Recupera Password"}
        className="w-full bg-orange-500 text-white py-3 rounded-md hover:bg-orange-600 mb-6"
      />
      
      <div className="text-center">
        <button
          type="button"
          onClick={() => onSwitchForm('login')}
          className="text-orange-500 hover:underline"
        >
          Torna al login
        </button>
      </div>
    </form>
  );
};

PasswordRecoveryForm.propTypes = {
  onSwitchForm: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  onResetError: PropTypes.func
};

export default PasswordRecoveryForm;